<template>
    <div>
        <div class="">
            <el-row class="data-head">
                <el-col :span="24">
                    <span>{{subjectName}} 分值统计</span>
                </el-col>
            </el-row>
            <el-row class="avg-data">
                <el-col :span="12">
                    <span class="avg-data-title">平均得分</span>
                    <div class="avg-data-detail">
                        <span class="avg-data-num">{{avgScore | formatAvgScore}}</span>
                        <span class="avg-data-unit">分</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <span>平均答题时长</span>
                    <div class="avg-data-detail">
                        <span class="avg-data-num">{{avgCostTime}}</span>
                        <span class="avg-data-unit">分钟</span>
                    </div>
                </el-col>
            </el-row>
            <el-row class="chart" :gutter="40">
                <el-col :span="12">
                    <high-charts :id="subjectId+'d'" :option="option1" ></high-charts>
                </el-col>
                <el-col :span="12">
                    <high-charts :id="subjectId+'x'" :option="option2" ></high-charts>
                </el-col>
            </el-row>
        </div>

        <!-- 柱状图 -->
        
        <!-- 饼图 -->
        <!-- <high-charts :id="sd" :option="sd"></high-charts> -->
    </div>
</template>
<script>
import HighCharts from  './HighCharts.vue';
let levelData = [
    {level:'levelA', name:'50分以下', y:0, p:0},
    {level:'levelB', name:'50-70分', y:0, p:0},
    {level:'levelC', name:'70-80分', y:0, p:0},
    {level:'levelD', name:'80-90分', y:0, p:0},
    {level:'levelE', name:'90分以上', y:0, p:0}
];
export default {
    name:'scoreData',
    components: {
        HighCharts
    },
    props: {
        subjectId: {
            type: Number,
            required: true
        },
        subjectName: {
            type: String,
            required: true
        },
        avgRealScore:{
            type: Number
        },
        avgScore:{
            type: Number
        },
        avgCostTime:{
            type: Number
        },
        levelDataList: {
            type: Array
        }
    },
    data :function(){
        return {
            option1:{
                chart: {
                    type: 'column'
                },
                title: {
                    text: null
                },
                xAxis: {
                    type: 'category'
                },
                yAxis: {
                    title: {
                        text: '分值等级统计（人次）'
                    }
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            format: '{point.y}',
                            style: {
                                fontWeight: 'normal',
                                color:'#666'
                            }
                        }
                    }
                },
                tooltip: {
                    enabled:false,
                },
                series: [{
                    colorByPoint: true,
                    data: levelData
                }],
                credits:{
                    enabled:false
                }
            },
            option2:{
                chart: {
                    type: 'pie'
                },
                title: {
                    text: '分值占比',
                    verticalAlign:'bottom',
                    y:-7,
                    style:{
                        color:'#666'
                    }
                },
                tooltip: {
                    enabled:false,
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        dataLabels: {
                            enabled: true,
                            format: '{point.p:.2f} %',
                            style: {
                                fontWeight: 'normal',
                                color:'#666'
                            }
                        },
                        showInLegend: true
                    }
                },
                legend:{
                    layout:'vertical',
                    align:'left',
                    verticalAlign:'top',
                    borderWidth:0,
                    itemStyle:{
                        fontWeight:'normal',
                        color:'#666'
                    }
                },
                series: [{
                    name: 'Brands',
                    colorByPoint: true,
                    data:levelData
                }],
                credits:{
                    enabled:false
                }
            }
        }
    },
    created() {
        this.convertLevelData(this.levelDataList);
        this.$set(this.option1.series, 0, {colorByPoint:true, data:this.levelDataList});
        this.$set(this.option2.series, 0, {colorByPoint:true, data:this.levelDataList});
    },
    mounted: ()=>{
        // this.$set(this.option1.series, 0, {colorByPoint:true, data:this.convertLevelData(this.levelDataList)});
    },
    methods: {
        convertLevelData(levelDataList) {
            let sum = 0;
            for (let obj of levelDataList) {
                if (obj.num !== undefined) {
                sum += obj.num;
                }
            }
            for (let i= 0; i < levelData.length; i++) {
                if (!levelDataList[i] || levelDataList[i].level != levelData[i].level) {
                    levelDataList.splice(i,0, levelData[i]);
                } else {
                    levelDataList[i].name = levelData[i].name;
                    levelDataList[i].y = levelDataList[i].num;
                }
                
                if (sum == 0) {
                    levelDataList[i].p = 0;
                } else {
                    levelDataList[i].p = (levelDataList[i].y * 100 / sum).toFixed(2)
                }
            }

            console.log(levelDataList);
            return levelDataList;
        }
    },
    filters: {
        formatAvgScore: score => {
            return parseFloat(score).toFixed(2);
        }
    }
};
</script>
<style scoped>
.data-head{
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
    margin-bottom: 10px;
    font-weight: bold;
    color:#666;
}
.avg-data{
    border-bottom: 2px dashed #ccc;
    color:#666
    /* height: 80px; */
    /* margin: 20px; */
}

.avg-data-detail {
    margin: 5px 0;
}
.avg-data-num{
    font-size: 30px;
    font-weight: bold;
    color: red;
    padding: 10px;
    /* margin: 5px 0; */
}

/* .avg-data-unit{
    color: #999;
} */
.chart {
    margin-top: 20px;
}
</style>
